import {startSubmit, stopSubmit} from 'redux-form'
import {all, call, put, takeLatest} from 'redux-saga/effects'

import {login, logout} from 'core/api/study_coordinator'
import {IActionLoginRequest, IActionLogoutRequest, tokenSet} from './actions'
import {LOGIN_REQUEST, LOGOUT_REQUEST} from './actionTypes'

/**
 * Dependencies needed for this saga
 */
export interface IDependencies {
  selectToken: () => void
  clearState: () => void
}

export function* loginRequest(action: IActionLoginRequest) {
  yield put(startSubmit(action.form))
  try {
    const response = yield call(login, action.payload)
    const data = response.data
    const { token } = data
    yield put(tokenSet({ token }))
    yield put(stopSubmit(action.form))
  } catch (e) {
    if (!e.response) {
      // TODO I18N
      const error = 'Network error. Please check your connection and try again.'
      yield put(stopSubmit(action.form, {_error: error}))
    } else {
      // TODO I18N
      let error = 'Server-side error'
      if (e.response && e.response.status === 401) {
        // TODO I18N
        error = 'Invalid credentials'
      }
      yield put(stopSubmit(action.form, {_error: error}))
    }
  }
}

export function* logoutRequestSaga(dependencies: IDependencies, action: IActionLogoutRequest) {
  const token = yield call(dependencies.selectToken)
  try {
    yield call(logout, token)
  } catch (e) {
    // Swallow error. The credentials may have expired by this point which would result in a 401.
    // But even if the request here fails, the token will expire eventually anyway.
  }
  yield call(dependencies.clearState)
}

function* loginSaga(dependencies: IDependencies) {
  yield all([
    takeLatest(LOGIN_REQUEST, loginRequest),
    takeLatest(LOGOUT_REQUEST, logoutRequestSaga, dependencies),
  ])
}

export default loginSaga



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/login/saga.ts